import { api } from './networkService';

class LoanService {
    static async fetch(page, filters) {
        try {
            const response = await api.get(`api/user/loan`, {
                params: {
                    page: page,
                    perPage: 20,
                    ...filters
                }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch loan error:', error);
            throw error;
        }
    }

    static async fetchAll(filters) {
        try {
            const response = await api.get(`api/user/loan`, {
                params: {
                    ...filters
                }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch loan error:', error);
            throw error;
        }
    }

    static async fetchOne(id) {
        try {
            const response = await api.get(`api/user/loan/${id}`);
            return response.data;
        } catch (error) {
            console.error('Fetch loan error:', error);
            throw error;
        }
    }

    static async add(loan) {
        try {
            const cleanedLoan = Object.fromEntries(
                Object.entries(loan).filter(([_, value]) => value && value !== '')
            );
            const response = await api.post(`api/user/loan`, cleanedLoan);
            return response;
        } catch (error) {
            console.error('Add loan error:', error);
            throw error;
        }
    }

    static async update(loan) {
        try {
            const { id, ...info } = loan;
            const cleanedLoan = Object.fromEntries(
                Object.entries(info).filter(([_, value]) => value && value !== '')
            );

            const response = await api.put(`api/user/loan/${id}`, cleanedLoan);
            return response;
        } catch (error) {
            console.error('Update loan error:', error);
            throw error;
        }
    }

    static async delete(id) {
        try {
            const response = await api.delete(`api/user/loan/${id}`);
            return response;
        } catch (error) {
            console.error('Delete loan error:', error);
            throw error;
        }
    }
}

export default LoanService;
